import { HealthcareProviderP1IntegrationCertificateMetadata } from '@dreryk/egabinet-p1-frontend-api';

import { isDemo } from '@dreryk/demo-variant-frontend';
import {
   appendTestableElementAttributes,
   CertificateInfo,
   CertificateUpload,
   StyledFlex,
} from '@dreryk/react-components';

import { certificatesFormTranslationKeys } from '../../../../translations';
import {
   CertificatesFormController,
   useCertificateNotificationLabels,
   useMapCertificatesMetadataToCertificate,
} from '../P1CertificatesForm.hooks';

import { CERTIFICATE_VALIDATION_MESSAGES } from './common/common.utils';

type WssCertificateUploadFieldProps = {
   readonly register: CertificatesFormController['register'];
   readonly wssCertificateMetadata?: HealthcareProviderP1IntegrationCertificateMetadata;
   readonly p1CertificatesLoading: boolean;
};

const WssCertificateUploadField = (props: WssCertificateUploadFieldProps): JSX.Element => {
   const wssCertificateMetadata = useMapCertificatesMetadataToCertificate(props.wssCertificateMetadata);
   const wssNotificationLabel = useCertificateNotificationLabels('wss');
   const isDemoMode = isDemo();
   const fileUploadPlaceholder = isDemoMode ? 'unavailableInDemo' : 'fileUploadPlaceholder';

   return (
      <StyledFlex gap={24} direction='column' {...appendTestableElementAttributes('wssCertificateUpload')}>
         <CertificateInfo
            certificate={wssCertificateMetadata}
            isLoading={props.p1CertificatesLoading}
            notificationLabels={wssNotificationLabel}
            testId={'wssCertificate'}
         />

         <CertificateUpload
            fileController={props.register('wssCertificateFile')}
            passwordController={props.register('wssCertificatePassword')}
            certificateLoading={props.p1CertificatesLoading}
            fileUploadLabel={certificatesFormTranslationKeys.wss.fileUploadLabel}
            fileUploadPlaceholder={certificatesFormTranslationKeys[fileUploadPlaceholder]}
            passwordLabel={certificatesFormTranslationKeys.wss.passwordLabel}
            validationMessages={CERTIFICATE_VALIDATION_MESSAGES}
            uploadDisabled={isDemoMode}
            testId={'p1CertificateUpload'}
         />
      </StyledFlex>
   );
};

export { WssCertificateUploadField };
